import { render, staticRenderFns } from "./ResearchOutputEligibility.vue?vue&type=template&id=383c43a8&scoped=true&"
import script from "./ResearchOutputEligibility.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputEligibility.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputEligibility.vue?vue&type=style&index=0&id=383c43a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383c43a8",
  null
  
)

export default component.exports